import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import authService from '../services/authService';
import driverService from '../services/driverService';
import PageHeader from '../components/common/PageHeader';
import toast from 'react-hot-toast';
import { getInitials } from '../utils/formatters';

export default function Profile() {
  const { user, fetchProfile } = useAuth();
  const [form, setForm]   = useState({ full_name: user?.full_name || '', phone: user?.phone || '', email: user?.email || '' });
  const [kpi, setKpi] = useState({ driver_monthly_profit_goal: '', driver_target_trip_count: '', notes: '' });
  const [loading, setLoading] = useState(false);
  const [kpiLoading, setKpiLoading] = useState(false);
  const isDriver = user?.role === 'driver';

  const handle = (e) => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  React.useEffect(() => {
    const loadKpi = async () => {
      if (!isDriver || !user?.id) return;
      try {
        const data = await driverService.getKPISettings(user.id);
        setKpi({
          driver_monthly_profit_goal: data.driver_monthly_profit_goal || '',
          driver_target_trip_count: data.driver_target_trip_count || '',
          notes: data.notes || '',
        });
      } catch {}
    };
    loadKpi();
  }, [isDriver, user?.id]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authService.updateProfile(form);
      await fetchProfile();
      toast.success('Profile updated');
    } finally { setLoading(false); }
  };

  const submitDriverKpi = async (e) => {
    e.preventDefault();
    if (!user?.id) return;
    setKpiLoading(true);
    try {
      await driverService.updateKPISettings(user.id, kpi);
      toast.success('Success targets updated');
    } finally { setKpiLoading(false); }
  };

  return (
    <div>
      <PageHeader title="Profile" subtitle="Manage your account information" />
      <div className="card" style={{ maxWidth: 540 }}>
        <div className="card-body">
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'var(--brand-black)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.25rem', fontWeight: 600, flexShrink: 0 }}>
              {getInitials(user?.full_name || user?.email)}
            </div>
            <div>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.125rem', fontWeight: 600 }}>{user?.full_name || 'Your Name'}</div>
              <div style={{ fontSize: '0.875rem', color: 'var(--gray-500)', textTransform: 'capitalize' }}>{user?.role === 'driver' ? 'Driver' : 'Fleet Owner'}</div>
            </div>
          </div>
          <form onSubmit={submit}>
            <div className="form-group">
              <label className="form-label">Full Name</label>
              <input className="form-control" name="full_name" value={form.full_name} onChange={handle} />
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-control" type="email" name="email" value={form.email} onChange={handle} disabled style={{ background: 'var(--gray-50)', color: 'var(--gray-500)' }} />
            </div>
            <div className="form-group">
              <label className="form-label">Phone</label>
              <input className="form-control" name="phone" value={form.phone} onChange={handle} placeholder="+254 7xx xxx xxx" />
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}>{loading ? 'Saving…' : 'Update Profile'}</button>
          </form>

          {isDriver && (
            <form onSubmit={submitDriverKpi} style={{ marginTop: '1.5rem', paddingTop: '1rem', borderTop: '1px solid var(--gray-100)' }}>
              <h4 style={{ margin: '0 0 0.75rem', fontFamily: 'var(--font-display)' }}>My Success Targets</h4>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">Monthly Profit Goal (KES)</label>
                  <input className="form-control" type="number" value={kpi.driver_monthly_profit_goal} onChange={(e) => setKpi(p => ({ ...p, driver_monthly_profit_goal: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label className="form-label">Trip Target (Count)</label>
                  <input className="form-control" type="number" value={kpi.driver_target_trip_count} onChange={(e) => setKpi(p => ({ ...p, driver_target_trip_count: e.target.value }))} />
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Notes</label>
                <textarea className="form-control" rows={2} value={kpi.notes} onChange={(e) => setKpi(p => ({ ...p, notes: e.target.value }))} />
              </div>
              <button className="btn btn-secondary" type="submit" disabled={kpiLoading}>{kpiLoading ? 'Saving…' : 'Save Success Targets'}</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}